// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputText_inputContainer__b4sHx","inputWarning":"InputText_inputWarning__N4Xm1"};